import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { AssignmentInfoResponse } from 'src/apis/assignment-service/types';
import type { AssignmentServiceRequest } from 'src/apis/assignment-service/use-assignment-service-root';
import type { Successful } from 'src/hooks/use-axios';
import { useAxios } from 'src/hooks/use-axios';

export function useAssignmentInfo({
  assignmentService,
  operatorId,
}: {
  assignmentService: Successful<AssignmentServiceRequest>;
  operatorId: string;
}) {
  const publicAssignmentInfo = useAxios(
    (axios, baseConfig, url: string) =>
      axios.request<AssignmentInfoResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    const url = urlTemplate
      .parse(assignmentService.response.data._links.assignmentInfo.href)
      .expand({ organisationId: operatorId });

    publicAssignmentInfo.execute(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operatorId]);

  return publicAssignmentInfo;
}

export type AssignmentInfoRequest = ReturnType<typeof useAssignmentInfo>;

export function useManualAssignmentInfo({
  assignmentService,
}: {
  assignmentService: Successful<AssignmentServiceRequest>;
}) {
  const assignmentInfo = useAxios(
    (axios, baseConfig, operatorId: string) => {
      const url = urlTemplate
        .parse(assignmentService.response.data._links.assignmentInfo.href)
        .expand({ organisationId: operatorId });
      return axios.request<AssignmentInfoResponse>({
        ...baseConfig,
        url,
      });
    },
    { neededOnPageLoad: false }
  );

  return assignmentInfo;
}

export type ManualAssignmentInfoRequest = ReturnType<
  typeof useManualAssignmentInfo
>;
